<template>
  <div>
    <v-layout row wrap>
      <v-flex>
        <div class="form">
          <h2>Nuevo Tunel</h2>
          <form @submit.prevent="onSubmit">
            <div class="input">
              <label for="name">Name</label>
              <input id="name" v-model="name" type="text" />
            </div>
            <div class="input">
              <label for="lines">Lineas</label>
              <input id="lines" v-model="lines" type="text" />
            </div>
            <!-- <div class="input">
              <label for="plantPots">PlantPots</label>
              <input id="plantPots" v-model="plantPots" type="text" />
            </div> -->
            <div class="input">
              <label for="parcelId">ParcelId</label>
              <input id="parcelId" v-model="parcelId" type="text" />
            </div>
            <div class="submit">
              <button type="submit">Enviar</button>
            </div>
          </form>
        </div>
      </v-flex>

      <v-flex>
        <div class="form">
          <h2>Cargar Tuneles</h2>
          <div class="input">
            <label for="tunnels">No. Tuneles </label>
            <input id="tunnels" v-model="tunnels" type="number" />
          </div>
          <div class="input">
            <label for="lines">Lineas</label>
            <input id="lines" v-model="lines" type="text" />
          </div>
          <div class="input">
            <label for="parcelId">ParcelId</label>
            <input id="parcelId" v-model="parcelId" type="text" />
          </div>
          <div v-if="tunnels > 0 && parcelId != null" class="submit">
            <button @click="submitMultiple()">Enviar</button>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axiosOld from "../axios-old";

export default {
  data() {
    return {
      tunnels: null,
      name: "",
      lines: 4,
      plantPots: 1,
      parcelId: null,
    };
  },
  methods: {
    onSubmit() {
      const formData = {
        // name: this.name,
        // mail: this.mail,
        // country: this.country,
        // phone: this.phone,
        name: this.name,
        lines: this.lines,
        plantPots: this.plantPots,
        parcelId: this.parcelId,
      };
      this.$store.dispatch("addTunel", formData);
    },
    async submitMultiple() {
      for (let i = 0; i < this.tunnels; i++) {
        // console.log("tunels", i + 1)
        const formData = {
          name: `Tunel ${i + 1}`,
          lines: this.lines,
          plantPots: this.plantPots,
          parcelId: this.parcelId,
        };
        // console.log("tunels", formData)
        await axiosOld
          .post("/api/tunel", formData)
          .then((res) => {
            console.log("Tunel registered!", res.data);
          })
          .catch((error) => console.error(error));
      }
    },
  },
};
</script>

<style scoped>
.form {
  width: 400px;
  margin: 30px auto;
  border: 1px solid #eee;
  padding: 20px;
  box-shadow: 0 2px 3px #ccc;
}

.input {
  margin: 10px auto;
}

.input label {
  display: block;
  color: #4e4e4e;
  margin-bottom: 6px;
}

.input.inline label {
  display: inline;
}

.input input {
  font: inherit;
  width: 100%;
  padding: 6px 12px;
  box-sizing: border-box;
  border: 1px solid #ccc;
}

.input.inline input {
  width: auto;
}

.input input:focus {
  outline: none;
  border: 1px solid #521751;
  background-color: #eee;
}

.input select {
  border: 1px solid #ccc;
  font: inherit;
}

.hobbies button {
  border: 1px solid #521751;
  background: #521751;
  color: white;
  padding: 6px;
  font: inherit;
  cursor: pointer;
}

.hobbies button:hover,
.hobbies button:active {
  background-color: #8d4288;
}

.hobbies input {
  width: 90%;
}

.submit button {
  border: 1px solid #521751;
  color: #521751;
  padding: 10px 20px;
  font: inherit;
  cursor: pointer;
}

.submit button:hover,
.submit button:active {
  background-color: #521751;
  color: white;
}

.submit button[disabled],
.submit button[disabled]:hover,
.submit button[disabled]:active {
  border: 1px solid #ccc;
  background-color: transparent;
  color: #ccc;
  cursor: not-allowed;
}
</style>
